module.exports = __webpack_public_path__ + "videos/webpush-safari-desktop.cbac1ec.mp4";